import { IIbgeCity, ICityModel } from 'entities';

export const convertIbgeCityToICity = (IbgeCity: IIbgeCity): ICityModel => {
  return {
    name: IbgeCity?.nome,
    id: IbgeCity?.id,
    microregionId: IbgeCity?.microrregiao?.id,
    uf: IbgeCity?.microrregiao?.mesorregiao?.UF?.sigla,
    ufCode: IbgeCity?.microrregiao?.mesorregiao?.UF?.id,
  };
};
